import React from 'react';
import { Route, IndexRoute } from 'react-router';
import deepmerge from 'deepmerge';

import extractNodeLevelData from './extractNodeLevelData';
import camelizePath from './camelizePath';
import metadataForNode from './metadataForNode';

const DEBUG = false;

function buildNestedRoute(node, components, attributes = {}, path = [], metadata = {}) {
  const { thisLevelMetadata, route } = extractNodeLevelData(node);

  return route.reduce((all, key, index) => {
    const newPath = [...path, key];

    const componentName = camelizePath(newPath.filter(part => part.indexOf(':') !== 0));
    const wrapperName = `${componentName}!wrapper`;

    const nextLevelData = extractNodeLevelData(node[key]);
    const nextLevelMetadata = metadataForNode(node[key]);
    const nextLevelRoutes = nextLevelData.route;

    const topRouteProps = {
      path: key,
      key: index,
    };

    const hasChildRoutes = nextLevelRoutes.length > 0;
    const wrapperComponent = components[wrapperName];
    let indexComponent;
    if (hasChildRoutes) {
      indexComponent = components[`${componentName}Index`];
    } else {
      indexComponent = components[componentName];
    }
    const indexMetadata = deepmerge(deepmerge(metadata, thisLevelMetadata), nextLevelMetadata);
    let childRoutes = [];

    if (DEBUG) {
      console.log('*****');
      console.log(path);
      console.log(newPath);
      console.log(key);
      console.log(hasChildRoutes);
      console.log(!!wrapperComponent);
      console.log(!!indexComponent);
      console.log('&&&&&');
    }

    if (hasChildRoutes) {
      childRoutes = buildNestedRoute(
        node[key],
        components,
        attributes,
        newPath,
        deepmerge(metadata, thisLevelMetadata),
      );
    }

    if (wrapperComponent) {
      topRouteProps.component = wrapperComponent;
    } else if (!hasChildRoutes) {
      topRouteProps.component = indexComponent;
      topRouteProps.metadata = indexMetadata;
    }

    if (!hasChildRoutes && !indexComponent) {
      throw new Error(
        `No component defined for endpoint ${newPath.join('/')}, should have ${componentName}`,
      );
    }

    return [
      ...all,
      <Route {...topRouteProps} {...attributes}>
        {childRoutes}
        {indexComponent &&
          <IndexRoute component={indexComponent} metadata={indexMetadata} {...attributes} />
        }
      </Route>,
    ];
  }, []);
}

export default function buildReactRouter(node, components, attributes) {
  return buildNestedRoute(node, components, attributes);
}
